import { render, staticRenderFns } from "./SelectSeat.vue?vue&type=template&id=5d209f06&"
import script from "./SelectSeat.vue?vue&type=script&lang=ts&"
export * from "./SelectSeat.vue?vue&type=script&lang=ts&"
import style0 from "./SelectSeat.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports